<template>
  <span
    class="user-avatar"
    :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${fontSize}px` }"
  >
    {{ initial }}
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  name: { type: String, default: '' },
  size: { type: [Number, String], default: 30 },
});

const initial = computed(() => props.name.trim().charAt(0).toUpperCase() || '?');
const fontSize = computed(() => Math.round(Number(props.size) * 0.42));
</script>

<style scoped>
.user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--melon);
  color: #fff8ec;
  font-family: 'Fraunces', serif;
  font-weight: 600;
  flex-shrink: 0;
}
</style>
